import React, { useMemo } from 'react';

export const FloatingDots = ({ count = 80, primaryColor = 'orange', secondaryColor = 'green' }) => {
  const dots = useMemo(() => {
    const dotsArray = [];
    for (let i = 0; i < count; i++) {
      const size = Math.random() * 4 + 1; // 1-5px
      const isBlurred = Math.random() > 0.5;
      const isPrimary = Math.random() > 0.5;
      const color = isPrimary ? primaryColor : secondaryColor;
      const shade = Math.floor(Math.random() * 3) + 3; // 300, 400, 500
      const opacity = Math.random() * 0.3 + 0.5; // 0.5-0.8
      const duration = Math.random() * 10 + 15; // 15-25s for slower movement
      const delay = Math.random() * 5; // 0-5s
      const top = Math.random() * 100; // 0-100%
      const left = Math.random() * 100; // 0-100%
      
      // Random movement pattern - Reduced range for better containment
      const moveX = Math.random() * 100 - 50; // -50 to 50px
      const moveY = Math.random() * 100 - 50; // -50 to 50px
      
      dotsArray.push({
        id: i,
        size,
        isBlurred,
        color: `${color}-${shade}00`,
        opacity,
        duration,
        delay,
        top,
        left,
        moveX,
        moveY
      });
    }
    return dotsArray;
  }, [count, primaryColor, secondaryColor]);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {dots.map((dot) => (
        <div
          key={dot.id}
          className={`absolute bg-${dot.color} rounded-full ${dot.isBlurred ? 'blur-sm' : ''}`}
          style={{
            top: `${dot.top}%`,
            left: `${dot.left}%`,
            opacity: dot.opacity,
            width: `${dot.size}px`,
            height: `${dot.size}px`,
            animation: `randomFloat-${dot.id} ${dot.duration}s ease-in-out infinite`,
            animationDelay: `${dot.delay}s`,
            willChange: 'transform',
            transform: 'translateZ(0)',
          }}
        >
          <style>{`
            @keyframes randomFloat-${dot.id} {
              0%, 100% {
                transform: translate3d(0, 0, 0) rotate(0deg);
              }
              25% {
                transform: translate3d(${dot.moveX * 0.5}px, ${dot.moveY * 0.3}px, 0) rotate(90deg);
              }
              50% {
                transform: translate3d(${dot.moveX}px, ${dot.moveY}px, 0) rotate(180deg);
              }
              75% {
                transform: translate3d(${dot.moveX * 0.3}px, ${dot.moveY * 0.7}px, 0) rotate(270deg);
              }
            }
          `}</style>
        </div>
      ))}
      
      {/* Large Glowing Orbs */}
      <div className="absolute top-1/4 right-1/4 w-32 h-32 bg-orange-400/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 left-1/4 w-40 h-40 bg-green-400/10 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '4s' }}></div>
      <div className="absolute top-1/2 left-1/2 w-36 h-36 bg-orange-300/10 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '6s', animationDelay: '1s' }}></div>
    </div>
  );
};
